export class DataResponse {
  constructor(public data?: any) {}

  [x: string]: any;
}
